import { TableColumn } from '@eas/common-web';

export function mergeSearchColumns<T>(
  baseColumns: TableColumn<T>[],
  searchColumns: TableColumn<T>[]
) {
  const searchColumnsByDatakey = new Map<string, TableColumn<T>>(
    searchColumns.map((column) => [column.datakey, column])
  );

  const mergedColumns = baseColumns.map((column) => {
    const searchColumn = searchColumnsByDatakey.get(column.datakey);

    if (!searchColumn) {
      return {
        ...column,
        filterable: false,
      };
    }

    searchColumnsByDatakey.delete(column.datakey);

    return {
      ...column,
      filterable: searchColumn.filterable,
      filterkey: searchColumn.filterkey,
      FilterComponent: searchColumn.FilterComponent,
      filterOperation: searchColumn.filterOperation,
      filterGroup: searchColumn.filterGroup,
      filterOrder: searchColumn.filterOrder,
      filterPath: searchColumn.filterPath,
      asciiFolding: searchColumn.asciiFolding,
    };
  });

  const searchOnlyColumns = Array.from(searchColumnsByDatakey.values()).map(
    (column) => ({
      ...column,
      hidden: true,
      visible: false,
    })
  );

  return [...mergedColumns, ...searchOnlyColumns];
}
